// Privacy Policy, Cookie Policy e banner cookie in italiano.
// Ogni sezione: { title, paragraphs?: [...], items?: [...] }. Nei testi è supportato <b>…</b>.
const legal = {
  updated: "Ultimo aggiornamento: 21 ottobre 2026",
  backToTop: "Torna su",

  privacy: {
    title: "Privacy Policy",
    intro:
      "Questa informativa descrive come Qapex S.R.L. tratta i dati personali degli utenti che visitano il sito qapex.it e ne utilizzano i servizi, ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (\"GDPR\") e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018.",
    sections: [
      {
        title: "1. Titolare del trattamento",
        paragraphs: [
          "<b>Qapex S.R.L.</b> – P.IVA IT03818350542 – Via della Louvière, n. 1/A, 06034 Foligno (PG), Italia.",
          "Per qualsiasi richiesta relativa ai tuoi dati personali puoi scriverci a <b>info@qapex.it</b>.",
        ],
      },
      {
        title: "2. Dati trattati",
        items: [
          "<b>Dati di navigazione</b>: indirizzo IP, tipo di browser e dispositivo, pagine visitate, data e ora della richiesta. Sono raccolti automaticamente dai sistemi che fanno funzionare il sito.",
          "<b>Dati forniti tramite il modulo contatti</b>: nome, cognome, email, telefono e il contenuto del messaggio.",
          "<b>Dati delle candidature</b>: nome, email, posizione per cui ti candidi e curriculum vitae, con i dati che vi sono contenuti.",
          "<b>Dati raccolti tramite cookie e strumenti di tracciamento</b>, solo se hai dato il consenso. Trovi i dettagli nella Cookie Policy.",
        ],
      },
      {
        title: "3. Finalità e basi giuridiche",
        items: [
          "<b>Rispondere alle tue richieste di contatto e di informazioni</b>: misure precontrattuali adottate su tua richiesta (art. 6.1.b GDPR).",
          "<b>Valutare le candidature e selezionare il personale</b>: misure precontrattuali su tua richiesta (art. 6.1.b) e, per i dati del CV, consenso (art. 6.1.a e art. 9.2.a per eventuali categorie particolari di dati).",
          "<b>Garantire il funzionamento e la sicurezza del sito</b>: legittimo interesse del Titolare (art. 6.1.f).",
          "<b>Misurare le visite al sito (Google Analytics) e l'efficacia delle campagne pubblicitarie (Meta Pixel)</b>: consenso (art. 6.1.a), che puoi revocare in qualsiasi momento.",
          "<b>Adempiere agli obblighi di legge e tutelare i diritti del Titolare</b>: obbligo legale (art. 6.1.c) e legittimo interesse (art. 6.1.f).",
        ],
      },
      {
        title: "4. Natura del conferimento",
        paragraphs: [
          "Fornire i dati richiesti nei moduli è facoltativo, ma senza di essi non possiamo rispondere alla tua richiesta né valutare la tua candidatura. Il consenso ai cookie di misurazione e marketing è facoltativo e rifiutarlo non limita la navigazione.",
        ],
      },
      {
        title: "5. Modalità del trattamento e destinatari",
        paragraphs: [
          "I dati sono trattati con strumenti elettronici e con misure di sicurezza adeguate. Possono accedervi il personale autorizzato del Titolare e i fornitori che erogano servizi per nostro conto, nominati responsabili del trattamento (art. 28 GDPR), tra cui:",
        ],
        items: [
          "fornitore di hosting del sito;",
          "Google LLC / Google Ireland Ltd (Google Workspace e Apps Script per la ricezione dei messaggi del modulo contatti; Google Fonts per i caratteri tipografici);",
          "FormSubmit (formsubmit.co) per l'inoltro via email delle candidature;",
          "Google Ireland Ltd (Google Analytics), solo previo consenso;",
          "Meta Platforms Ireland Ltd (Meta Pixel), solo previo consenso.",
        ],
      },
      {
        title: "6. Trasferimento dei dati extra UE",
        paragraphs: [
          "Alcuni dei fornitori indicati possono trattare i dati negli Stati Uniti. In questi casi il trasferimento avviene sulla base del Data Privacy Framework UE-USA, quando il fornitore vi aderisce, oppure delle Clausole Contrattuali Standard approvate dalla Commissione europea.",
        ],
      },
      {
        title: "7. Periodo di conservazione",
        items: [
          "Richieste di contatto: per il tempo necessario a gestire la richiesta e, in ogni caso, non oltre 24 mesi dall'ultimo contatto.",
          "Candidature: non oltre 24 mesi dalla ricezione, salvo che tu chieda prima la cancellazione.",
          "Dati di navigazione: per il tempo strettamente necessario alla sicurezza del sito, salvo accertamento di illeciti.",
          "Dati raccolti tramite cookie: secondo le durate indicate nella Cookie Policy.",
        ],
      },
      {
        title: "8. I tuoi diritti",
        paragraphs: [
          "In qualsiasi momento puoi chiedere l'accesso ai tuoi dati, la rettifica, la cancellazione, la limitazione del trattamento e la portabilità, e puoi opporti al trattamento basato sul legittimo interesse (artt. 15–22 GDPR). Puoi revocare il consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento effettuato prima della revoca.",
          "Per esercitare i tuoi diritti scrivi a <b>info@qapex.it</b>. Se ritieni che il trattamento violi il GDPR, puoi proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
        ],
      },
      {
        title: "9. Collegamenti (link) a siti esterni",
        paragraphs: [
          "Questo sito contiene collegamenti ipertestuali (link), cioè strumenti che consentono il collegamento a pagine web di altri siti: i siti esterni raggiungibili tramite link sono sviluppati e gestiti da soggetti sui quali Qapex Srl non ha alcuna titolarità né controllo e non è in alcun modo responsabile circa contenuti, qualità, accuratezza e servizi offerti. La visita e l'utilizzo dei siti consultati dall'utente dal presente sito tramite link, quindi, è rimessa esclusivamente alla totale discrezionalità e responsabilità dell'utente utilizzatore.",
          "La presente informativa, pertanto, è resa solo per il sito Qapex.it e non anche per altri siti web eventualmente consultati dall'utente tramite link.",
        ],
      },
      {
        title: "10. Modifiche",
        paragraphs: [
          "Possiamo aggiornare questa informativa. La versione in vigore è sempre pubblicata su questa pagina, con la data dell'ultimo aggiornamento.",
        ],
      },
    ],
  },

  cookie: {
    title: "Cookie Policy",
    intro:
      "I cookie sono piccoli file di testo che il sito salva sul tuo dispositivo. Questa pagina spiega quali cookie e tecnologie simili (come il local storage) usa qapex.it e come puoi gestirli.",
    sections: [
      {
        title: "1. Strumenti tecnici (sempre attivi)",
        paragraphs: [
          "Sono necessari al funzionamento del sito e non richiedono consenso.",
        ],
        items: [
          "<b>qapex_cookie_consent</b> (local storage, Qapex): memorizza la tua scelta sui cookie. Durata: 12 mesi.",
          "<b>Google Fonts</b> (Google): fornisce i caratteri tipografici del sito. Non installa cookie, ma riceve l'indirizzo IP del browser per inviare i file.",
        ],
      },
      {
        title: "2. Cookie di misurazione e marketing (solo con consenso)",
        paragraphs: [
          "Sono attivati solo se clicchi \"Accetta\" nel banner.",
        ],
        items: [
          "<b>Google Analytics 4</b> (Google Ireland Ltd): misura in forma aggregata le visite al sito, le pagine viste e la provenienza dei visitatori. Cookie: _ga (2 anni), _ga_D13SGH4CKN (2 anni). Informativa: policies.google.com/privacy.",
          "<b>Meta Pixel</b> (Meta Platforms Ireland Ltd): misura le visite provenienti dalle campagne pubblicitarie su Facebook e Instagram e permette di mostrare annunci pertinenti. Cookie: _fbp (3 mesi), fr (3 mesi). Informativa: www.facebook.com/privacy/policy.",
        ],
      },
      {
        title: "3. Come gestire il consenso",
        paragraphs: [
          "Al primo accesso puoi accettare o rifiutare i cookie di misurazione e marketing dal banner. Puoi cambiare idea in qualsiasi momento con il pulsante \"Preferenze cookie\" in fondo a questa pagina. Puoi anche cancellare o bloccare i cookie dalle impostazioni del tuo browser.",
          "Per tutto il resto (titolare, diritti, contatti) consulta la Privacy Policy.",
        ],
      },
    ],
  },

  banner: {
    text:
      "Noi (qapex.it) e terze parti selezionate (3) utilizziamo cookie o tecnologie simili per finalità tecniche e, con il tuo consenso, anche per le finalità di <b>funzionalità, esperienza, misurazione e “marketing (con annunci personalizzati)”</b> come specificato nella <link>cookie policy</link>.",
    text2:
      "Puoi liberamente prestare, rifiutare o revocare il tuo consenso, in qualsiasi momento, accedendo al pannello delle preferenze. Il rifiuto del consenso può rendere non disponibili le relative funzioni.",
    text3: "Usa il pulsante “Accetta” per acconsentire. Usa il pulsante “Rifiuta” per continuare senza accettare.",
    customize: "Scopri di più e personalizza",
    necessaryTitle: "Necessari",
    necessaryText: "Strumenti indispensabili al funzionamento del sito, come il salvataggio delle tue preferenze sui cookie.",
    alwaysOn: "Sempre attivi",
    marketingTitle: "Misurazione e marketing",
    marketingText: "Google Analytics: misura in forma aggregata le visite al sito. Meta Pixel: misura le visite provenienti dalle nostre campagne su Facebook e Instagram e permette di mostrare annunci personalizzati.",
    save: "Salva e continua",
    accept: "Accetta",
    reject: "Rifiuta",
    settings: "Preferenze cookie",
  },
};

export default legal;
